export const attachmentBoxStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  backgroundColor: '#f7f7f7',
  borderRadius: 1,
  px: 1,
  py: 0.5,
  minWidth: '100px',
};

export const attachmentLinkStyles = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
};
